module.exports = __webpack_public_path__ + "img/about-us-text.c12fcb61.svg";